import { Drawer, Box, CircularProgress } from "src/components"
import { useIsMobile } from "src/hooks"
import { useNavigate } from "react-router-dom";
import { formatDistanceToNowStrict } from "date-fns";

import ChatSidebarContent from './chat-sidebar-content';

export default function ChatSidebarContainer({ open, loadingChats, chatUpdates, chats = [], toggleSidebar }) {
  const isMobile = useIsMobile()
  const navigate = useNavigate();

  const directChats = chats.filter(c => c.type.toLowerCase() === "direct") || [];
  const groupChats = chats.filter(c => c.type.toLowerCase() === "group") || [];

  const handleAiClick = () => {
    navigate("/chat/ai");
    if (open) toggleSidebar(); 
  };

  const handleChatClick = (userId) => {
    navigate(`/chat/direct/${userId}`);
    if (open) toggleSidebar();
  };

  const handleGroupClick = (groupId) => {
    navigate(`/chat/group/${groupId}`);
    if (open) toggleSidebar();
  };

  const computedDirectChats = directChats.map(chat => {
    const update = chatUpdates[chat.id] || {};
    return {
      ...chat,
      lastMessage: update.lastMessage || chat.lastMessage,
      lastMessageSentAt: update.timestamp || chat.lastMessageSentAt,
      timestamp: update.timestamp ? formatTimestamp(update.timestamp) : chat.timestamp,
      unreadCount: !chat.currentUserLastReadAt ||chat.currentUserLastReadAt < chat.lastMessageSentAt ? 1 : 0,
    };
  });

  const computedGroupChats = groupChats.map(chat => {
    const update = chatUpdates[chat.id] || {};
    return {
      ...chat,
      lastMessage: update.lastMessage || chat.lastMessage,
      lastMessageSentAt: update.timestamp || chat.lastMessageSentAt,
      timestamp: update.timestamp ? formatTimestamp(update.timestamp) : chat.timestamp,
      unreadCount: !chat.currentUserLastReadAt ||chat.currentUserLastReadAt < chat.lastMessageSentAt ? 1 : 0,
    };
  });

  // Drawer content
  const drawerContent = (
    <ChatSidebarContent 
      toggleSidebar={toggleSidebar}
      handleAiClick={handleAiClick}
      handleChatClick={handleChatClick}
      handleGroupClick={handleGroupClick}
      chats={computedDirectChats}
      chatUpdates={chatUpdates}
      groups={computedGroupChats}
    />
  )

  const loader = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%", 
      }}>
      <CircularProgress size={32} />
    </Box>
  )

  if (isMobile) {
    return (
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleSidebar}
        ModalProps={{
          keepMounted: true,
        }}
        variant="temporary"
        PaperProps={{
          sx: { 
            width: "auto", 
            backgroundColor: "#fafafa",
            paddingBottom: 'var(--safe-area-bottom)',
            paddingTop: 'var(--safe-area-top)', },
        }}
      >
        {loadingChats ? loader : drawerContent}
      </Drawer>
    )
  }

  return (
    <Box
      sx={{
        width: 320,
        flexShrink: 0,
        height: "100%",
        position: "sticky",
        top: 0,
        borderRight: "1px solid #e0e0e0",
        backgroundColor: "#fafafa",
      }}
    >
      {loadingChats ? loader : drawerContent}
    </Box>
  )
}

function formatTimestamp(timestamp) {
  return formatDistanceToNowStrict(new Date(timestamp), { addSuffix: false })
    .replace(" minutes", "m")
    .replace(" minute", "m")
    .replace(" hours", "h")
    .replace(" hour", "h")
    .replace(" days", "d")
    .replace(" day", "d")
    .replace(" seconds", "s")
    .replace(" second", "s");
}
